<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="teams-list min-height-100"
      v-loading="loading">
      <add
        @trace-tokens-updated="getData()"/>
      <div v-if="traceTokens !== null">
        <el-table
          :data="traceTokens.list"
          border
          style="width: 100%"
          class="mb-15 mt-15">
          <el-table-column
            :label="$t('status')">
            <template slot-scope="scope">
              <el-tag
              :type="scope.row.expiry > 0 ?
              'success' : 'danger'"
              class="no-margin">
                {{ scope.row.expiry > 0 ? $t('active') : $t('deactive') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('campaign_name')">
            <template slot-scope="scope">
              <div v-bind:style="{direction: 'ltr'}">
                <span>{{ scope.row.campaign }} </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="trace_token"
            :label="$t('trace_token')">
          </el-table-column>
          <el-table-column
            prop="plan.name"
            :label="$t('plan')">
          </el-table-column>
          <el-table-column
            :label="$t('plan_expiration')">
            <template slot-scope="scope">
              {{ convertSeconds(scope.row.plan_remaining) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('token_expiration')">
            <template slot-scope="scope">
              {{ convertSeconds(scope.row.expiry) }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('tools')" width="180">
            <template slot-scope="scope">
              <el-tooltip
                v-if="role.name==='zeus' || role.name==='marketing_manager'"
                class="item"
                effect="dark"
                :content="$t('edit')"
                placement="top-start">
                <el-button
                  size="mini"
                  @click="handleTraceTokenEdit(scope.$index, scope.row)"
                  type="warning">
                  <i class="fas fa-pen"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip
                v-if="role.name==='zeus' || role.name==='marketing_manager'"
                class="item"
                effect="dark"
                :content="$t('members')"
                placement="top-start">
                <router-link
                  :to="{ name: 'trace_token_users', params: {lid: scope.row.id.numberStr}, query:{ name: scope.row.campaign }}"
                  class="el-button el-button--info el-button--mini is-plain">
                  <i class="fas fa-users"></i>
                </router-link>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('copy_the_trace_token')"
                placement="top-start">
                <el-button
                  size="mini"
                  v-clipboard:copy="traceTokenLink(scope.row.trace_token)"
                  v-clipboard:success="onCopy"
                  class="el-button el-button--info el-button--mini is-plain">
                  <i class="fas fa-copy"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="traceTokens.total"
          :page-size="limit"
          :current-page.sync="currentPage">
        </el-pagination>
      </div>
      <edit
        :traceToken="traceToken"
        :user="userID"
        :traceTokens="traceTokens"
        @close-clicked="dialogVisible = false"
        @trace-token-updated="updateRowTraceToken($event)"
        :dialog-visible="dialogVisible" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Edit from '@/components/traceTokens/Edit'
import Add from '@/components/traceTokens/Add'

export default {
  data () {
    return {
      addTraceTokenDialogVisible: false,
      dialogVisible: false,
      currentPage: 1,
      loading: false,
      currentRow: 0,
      userID: '',
      query: {},
      limit: 10,
      traceToken: {}
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'teams',
      'traceTokens',
      'plans',
      'role'
    ]),
    offset () {
      return (this.currentPage - 1) * this.limit
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    updateRowTraceToken (traceToken) {
      this.dialogVisible = false
      this.getData()
    },
    handleTraceTokenEdit (currentRow, traceToken) {
      this.traceToken = traceToken
      this.dialogVisible = true
      this.currentRow = currentRow
      this.userID = traceToken.id.numberStr
    },
    async getData () {
      const { limit, offset, query } = this
      const { domainsPath } = this
      this.toggleLoading()
      this.handleRequest({
        name: `trace_tokens`,
        action: 'getAll',
        mutation: 'SET_TRACE_TOKENS',
        data: {
          query: {
            limit,
            offset,
            ...query
          }
        }
      }).then(this.toggleLoading)

      this.handleRequest({
        name: `${domainsPath}/plans`,
        action: 'getAll',
        mutation: 'SET_PLANS',
        data: {
          query: {
            limit: 200
          }
        }
      })
    },
    onCopy () {
      this.$message({
        message: this.$i18n.t('copy_trace_token'),
        type: 'success'
      })
    },
    traceTokenLink (t) {
      return `https://${process.env.VUE_APP_SERVER_URL}/#/register?trace_token=${t}`
    }
  },
  watch: {
    currentPage () {
      this.getData()
    }
  },
  created () {
    this.getData()
  },
  components: {
    Edit,
    Add
  }
}
</script>
